import { NgModule }              from '@angular/core';
import { UIRouterUpgradeModule } from '@uirouter/angular-hybrid';

import { AJS_VENDOR_PROVIDER }             from '../vendors/vendor.quick-add.provider.ajs';
import { PartsAuthoritySettingsComponent } from './parts-authority.settings.component';
import { PartsAuthorityStates }            from './parts-authority.states';
import { SharedModule }                    from '../shared/shared.module';

@NgModule({
  declarations: [
    PartsAuthoritySettingsComponent
  ],
  entryComponents: [
    PartsAuthoritySettingsComponent
  ],
  imports: [
    SharedModule,

    UIRouterUpgradeModule.forChild({ states: PartsAuthorityStates })
  ],
  providers: [
    AJS_VENDOR_PROVIDER
  ]
})
export class PartsAuthorityModule {}
